import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { api } from '@/shared/api';
import { ROUTES } from '@/shared/config/routes';

/**
 * Signing out of the client hub.
 *
 * The dialog used to close and navigate home while the session stayed open.
 * The cache is emptied on settle, not only on success, for the same reason as
 * the master's logout: a failed request must not leave one person's bookings
 * behind for the next.
 */
export const useClientSignOut = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: () => api.post<null>('/auth/logout'),
    onSettled: () => {
      queryClient.clear();
      void navigate(ROUTES.home, { replace: true });
    },
  });
};
